import React from 'react';
import { NavLink } from 'react-router-dom';

const Navbar: React.FC = () => (
	<nav className='d-flex h-100 justify-content-center'>
		<ul>
			<li>
				<NavLink to="/assets">Assets</NavLink>
			</li>

			<li>
				<NavLink to="/map">Map</NavLink>
			</li>
		</ul>
	</nav>
);

export default Navbar;
